import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { DrawAddressLink } from './components/DrawAddressLink';
import { ResignDrawButton } from './components/ResignDrawButton';
import { useNavigate } from 'react-router';
import { isMobileScreen } from '@apply/ui';

interface ResignDrawCardProps {
    dashboardDrawBudget: IDashboardDrawBudget;
}

export const ResignDrawCard: React.FC<ResignDrawCardProps> = ({ dashboardDrawBudget }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (isMobileScreen()) {
            navigate(`/mobilereviewandsubmit/${dashboardDrawBudget.drawBudgetId}`);
        } else {
            navigate(`/draw/${dashboardDrawBudget.drawBudgetId}`);
        }
    };
    return (
        <div className='row draw-pending-container'>
            <DrawAddressLink dashboardDrawBudget={dashboardDrawBudget} />
            <div className='draw-pending-button'>
                <ResignDrawButton handleClick={handleClick} />
            </div>
        </div>
    );
};
